import imgNews from '@/assets/blog.png';
import { StaticImport } from 'next/dist/shared/lib/get-img-props';
import Image from 'next/image';

type BannerProps = {
  topTitle?: string;
  midTitle?: string;
  title?: string;
  description?: string;
  img?: string | StaticImport;
  bright?: boolean;
  align?: 'left' | 'right' | 'center';
};
export default function Banner({
  description,
  img = imgNews,
  title,
  topTitle,
  midTitle,
  bright = false,
  align,
}: BannerProps) {
  return (
    <section className="w-full max-w-[1440px] max-sm:max-h-[186px] h-[260px] mx-auto bg-black text-crunchies-white py-20 px-5 rounded-3xl relative overflow-hidden grid gap-10 text-center">
      <Image
        src={img}
        alt="image news"
        fill
        className={`w-full h-full object-cover ${bright ? 'opacity-80' : 'opacity-50'}`}
        priority
      />
      <div className="space-y-2 text-crunchies-white z-10">
        {topTitle && (
          <h1 className="lg:text-7xl text-4xl z-10 font-symphony font-medium">
            {topTitle}
          </h1>
        )}
        {midTitle && (
          <h1 className="lg:text-7xl text-4xl z-10 font-symphony font-medium">
            {midTitle}
          </h1>
        )}
        {title && (
          <h1
            className={`lg:text-7xl text-4xl z-10 font-symphony tracking-wider leading-10 font-medium ${`text-${align}`}`}
          >
            {title}
          </h1>
        )}
      </div>
      <p className="w-full text-lg z-10">
        {description === 'undefined' ? '' : description}
      </p>
    </section>
  );
}
